import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { ko } from 'date-fns/locale';
import App from './App.tsx';
import './assets/css/index.css';
import { LoadingProvider } from '@/contexts/LoadingContext.tsx';

registerLocale('ko', ko); // 달력언어설정
setDefaultLocale('ko');

ReactDOM.createRoot(document.getElementById('root')!).render(
    /*<React.StrictMode>*/
    <LoadingProvider>
        <App />
    </LoadingProvider>,
    /*</React.StrictMode>,*/
);
